import { QueryFunctionContext } from '@tanstack/react-query';

import { SetsConfigService } from 'src/services/SetsConfigService';

export const QUERY_KEY = 'sets_config';

export const querySetsConfig = (
    context: QueryFunctionContext<App.SetsConfigs.ConfigQueryKey, number>,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig | null> => {
    const { queryKey } = context;
    const [, accessToken, productKey] = queryKey;

    return SetsConfigService.getSetsConfig(accessToken, productKey);
};
